var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab"},[_c('div',{staticClass:"tab__header",class:[
			{ 'tab__header--completed': _vm.completed },
			{ 'tab__header--active': _vm.active }
		],on:{"click":function($event){return _vm.$emit('changedTab', _vm.id)}}},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.active),expression:"active"}],staticClass:"tab__body"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }